import { search as getLocationSearch } from 'core-framework/window/location';
import { QueryString } from 'core/utils/queryString/queryString';

export const getActivityIdQueryString = (): { searchString: string; activityIdFromUrl?: number } => {
    const searchString = getLocationSearch();
    const qs = new QueryString(searchString);
    const queryActivityId = qs.get('activityId') || '';
    const activityIdFromUrl = parseInt(queryActivityId, 10) || undefined;
    return { searchString, activityIdFromUrl };
};
